import React from 'react'
import GravityForm from './gravity-form'

const subscribeCard = ({ data }) => {
  const gravityFormId = data?.wp?.themeOptions?.acfOptions?.gravityFormId
    ? data?.wp?.themeOptions?.acfOptions?.gravityFormId
    : ''

  const gravityFormEnabled = data?.wp?.themeOptions?.acfOptions?.gravityFormEnabled
    ? data?.wp?.themeOptions?.acfOptions?.gravityFormEnabled
    : ''

  return (
    <div className='subscribe-card rounded-t-2xl overflow-hidden border border-gray-light'>
      <div
        dangerouslySetInnerHTML={{
          __html: data?.wp?.themeOptions?.acfOptions?.hubspotSubscribeTitle,
        }}
      ></div>
      <div className='subscribe-card__body'>
        <div
          dangerouslySetInnerHTML={{
            __html: data?.wp?.themeOptions?.acfOptions?.hubspotSubscribeDescription,
          }}
        ></div>
        {gravityFormEnabled && gravityFormId ? (
          <>
            <div className='p-4' id='gFormSubscribe'></div>
            <GravityForm
              portalRef='gFormSubscribe'
              formPageSettings={data?.wp?.themeOptions?.acfOptions}
              form={data?.form}
            />
          </>
        ) : (
          ''
        )}
      </div>
    </div>
  )
}

export default subscribeCard
